webpackJsonp([222102899033736],{

/***/ 602:
/***/ (function(module, exports) {

	module.exports = {"data":{"projectsJson":{"name":"Typography","keywords":["Birdfont","Handwriting","IPA","Phonetics"],"status":null,"tagline":"Since first grade, I had dreamed of turning my handwriting into a font.","year":[2015],"description":"Since first grade, I had dreamed of turning my handwriting into a font. **Dream achieved**.\n\nI also made a custom font for typing common characters from the International Phonetic Alphabet, for when one is wont to write phonetically.","images":["typography.png-noShadow"],"videos":null,"id":"/Users/davidbaker/code/davidbaker.is/src/data/projects.json absPath of file [9] >>> JSON","logo":null,"link":"https://github.com/davvidbaker/fonts/wiki/Fonts","linkToSource":null,"linkToTrello":null,"callToAction":"Get the fonts!","teammates":null,"agency":null}},"pathContext":{"projectPath":"a-lettering-artist"}}

/***/ })

});


// WEBPACK FOOTER //
// path---a-lettering-artist-92fa7bfb0a10c69f9821.js